import { styled, Typography } from '@mui/material'
import i18n from '../../../i18n'

const Wrap = styled(Typography)`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.color.text100};
`

export const PopupTitle = () => {
  return <Wrap>{i18n.t('Notification', { defaultValue: 'Notification' })}</Wrap>
}
